import { Database, InterpretedDatabase } from '@amzn/awscat-portfolio-assessment-types';

// TODO: This entire file should be replaced. Column definitions should be generated from this file in Data models package
// https://code.amazon.com/packages/AWSCAT-PortfolioDataModels/blobs/mainline/--/src/models/schema/fixed-schema/database-headers.ts
export const DatabaseColumnDefinition: {[key in keyof InterpretedDatabase<Database>]: any} = {
    portfolioId: {
        cell: (item: InterpretedDatabase<Database>) => item.portfolioId,
        header: 'Portfolio ID',
        hidden: true,
        id: 'portfolioId',
    },
    databaseId: {
        cell: (item: InterpretedDatabase<Database>) => item.databaseId,
        header: 'Database ID',
        hidden: true,
        id: 'databaseId',
    },
    dbName: {
        cell: (item: InterpretedDatabase<Database>) => item.dbName,
        header: 'DB Name',
        hidden: true,
        id: 'dbName',
    },
    dbInstanceName: {
        cell: (item: InterpretedDatabase<Database>) => item.dbInstanceName,
        header: 'DB Instance Name',
        hidden: true,
        id: 'dbInstanceName',
    },
    dbInstanceEngine: {
        cell: (item: InterpretedDatabase<Database>) => item.dbInstanceEngine,
        header: 'DB Instance Engine/Software',
        hidden: true,
        id: 'dbInstanceEngine',
    },
    dbInstanceVersion: {
        cell: (item: InterpretedDatabase<Database>) => item.dbInstanceVersion,
        header: 'DB Instance Engine/Software Version',
        hidden: true,
        id: 'dbInstanceVersion',
    },
    size: {
        cell: (item: InterpretedDatabase<Database>) => item.size,
        header: 'DB Size (KB)',
        hidden: true,
        id: 'size',
    },
    serverId: {
        cell: (item: InterpretedDatabase<Database>) => item.serverId,
        header: 'Server ID',
        hidden: true,
        id: 'serverId',
    },
    targetDBType: {
        cell: (item: InterpretedDatabase<Database>) => item.targetDBType,
        header: 'Target AWS DB Service',
        hidden: true,
        id: 'targetDBType',
    },
    deploymentPlan: {
        cell: (item: InterpretedDatabase<Database>) => item.deploymentPlan,
        header: 'DB Instance Deployment Option',
        hidden: true,
        id: 'deploymentPlan',
    },
    dbOwnerId: {
        cell: (item: InterpretedDatabase<Database>) => item.dbOwnerId,
        header: 'dbOwnerId',
        hidden: true,
        id: 'dbOwnerId',
    },
    dbOwnerName: {
        cell: (item: InterpretedDatabase<Database>) => item.dbOwnerName,
        header: 'dbOwnerName',
        hidden: true,
        id: 'dbOwnerName',
    },
    dbOwnerEmail: {
        cell: (item: InterpretedDatabase<Database>) => item.dbOwnerEmail,
        header: 'DB Owner Email',
        hidden: true,
        id: 'dbOwnerEmail',
    },
    dbOwnerPhone: {
        cell: (item: InterpretedDatabase<Database>) => item.dbOwnerPhone,
        header: 'DB Owner Phone',
        hidden: true,
        id: 'dbOwnerPhone',
    },
    edition: {
        cell: (item: InterpretedDatabase<Database>) => item.edition,
        header: 'Enterprise / Standard Edition',
        hidden: true,
        id: 'edition',
    },
    replication: {
        cell: (item: InterpretedDatabase<Database>) => item.replication,
        header: 'Replication (Y/N)',
        hidden: true,
        id: 'replication',
    },
    oracleAdr: {
        cell: (item: InterpretedDatabase<Database>) => item.oracleAdr,
        header: 'Oracle ADR (Y/N)',
        hidden: true,
        id: 'oracleAdr',
    },
    oracleRacCluster: {
        cell: (item: InterpretedDatabase<Database>) => item.oracleRacCluster,
        header: 'Cluster / Oracle RAC (Y/N)',
        hidden: true,
        id: 'oracleRacCluster',
    },
    maxIops: {
        cell: (item: InterpretedDatabase<Database>) => item.maxIops,
        header: 'Maximum IOPS',
        hidden: true,
        id: 'maxIops',
    },
    maxTransactionsPerSec: {
        cell: (item: InterpretedDatabase<Database>) => item.maxTransactionsPerSec,
        header: 'Maximum User Transactions Per Second',
        hidden: true,
        id: 'maxTransactionsPerSec',
    },
    redoLogKB: {
        cell: (item: InterpretedDatabase<Database>) => item.redoLogKB,
        header: 'Redo Log Size Per Hour (KB)',
        hidden: true,
        id: 'redoLogKB',
    },
    storedProcedureLinesOfCode: {
        cell: (item: InterpretedDatabase<Database>) => item.storedProcedureLinesOfCode,
        header: 'Stored Procedures (Lines of Code)',
        hidden: true,
        id: 'storedProcedureLinesOfCode',
    },
    triggerLinesOfCode: {
        cell: (item: InterpretedDatabase<Database>) => item.triggerLinesOfCode,
        header: 'Triggers (Lines of Code)',
        hidden: true,
        id: 'triggerLinesOfCode',
    },
    wqfRating: {
        cell: (item: InterpretedDatabase<Database>) => item.wqfRating,
        header: 'WQF Rating (1-5)',
        hidden: true,
        id: 'wqfRating',
    },
    rType: {
        cell: (item: InterpretedDatabase<Database>) => item.rType,
        header: 'Migration strategy',
        hidden: true,
        id: 'rType',
    },
    cpuCores: {
        cell: (item: InterpretedDatabase<Database>) => item.cpuCores,
        header: 'Number of CPU Cores',
        hidden: true,
        id: 'cpuCores',
    },
    dbUtilization: {
        cell: (item: InterpretedDatabase<Database>) => item.dbUtilization,
        header: 'Database Utilization',
        hidden: true,
        id: 'dbUtilization',
    },
    dbThroughput: {
        cell: (item: InterpretedDatabase<Database>) => item.dbThroughput,
        header: 'Database Throughput',
        hidden: true,
        id: 'dbThroughput',
    },
    averageIops: {
        cell: (item: InterpretedDatabase<Database>) => item.averageIops,
        header: 'Average IOPS',
        hidden: true,
        id: 'averageIops',
    },
    isSharedInfrastructure: {
        cell: (item: InterpretedDatabase<Database>) => item.isSharedInfrastructure,
        header: 'isSharedInfrastructure',
        hidden: true,
        id: 'isSharedInfrastructure',
    },
    environment: {
        cell: (item: InterpretedDatabase<Database>) => item.interpretedFields?.environment.label,
        header: 'Environment',
        hidden: true,
        id: 'environment',
    },
    inScope: {
        cell: (item: InterpretedDatabase<Database>) => item.inScope,
        header: 'In Scope of Portfolio',
        hidden: true,
        id: 'inScope',
    },
    questionnaireId: {
        cell: (item: InterpretedDatabase<Database>) => item.questionnaireId,
        header: 'Questionnaire ID',
        hidden: true,
        id: 'questionnaireId',
    },
    rdsRecommendationOverrideAvgUtilization: {
        cell: (item: InterpretedDatabase<Database>) => item.rdsRecommendationOverrideAvgUtilization,
        header: 'rdsRecommendationOverrideAvgUtilization',
        hidden: true,
        id: 'rdsRecommendationOverrideAvgUtilization',
    },
    rdsRecommendationOverridePeakUtilization: {
        cell: (item: InterpretedDatabase<Database>) => item.rdsRecommendationOverridePeakUtilization,
        header: 'rdsRecommendationOverridePeakUtilization',
        hidden: true,
        id: 'rdsRecommendationOverridePeakUtilization',
    },
    rdsRecommendationOverrideOnPremCapacity: {
        cell: (item: InterpretedDatabase<Database>) => item.rdsRecommendationOverrideOnPremCapacity,
        header: 'rdsRecommendationOverrideOnPremCapacity',
        hidden: true,
        id: 'rdsRecommendationOverrideOnPremCapacity',
    },
    licenseModel: {
        cell: (item: InterpretedDatabase<Database>) => item.licenseModel,
        header: 'License Model',
        hidden: true,
        id: 'licenseModel',
    },
    createdAt: {
        cell: (item: InterpretedDatabase<Database>) => item.createdAt,
        header: 'Created At',
        hidden: true,
        id: 'createdAt',
    },
    updatedAt: {
        cell: (item: InterpretedDatabase<Database>) => item.updatedAt,
        header: 'Updated At',
        hidden: true,
        id: 'updatedAt',
    },
};
